var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"status-button d-flex layout-row align-items-center i-text-button-2 i-pl-6 i-pr-6 i-pt-4 i-pb-4",class:{
    selected: _vm.active,
    approve: _vm.btnStatus === _vm.options.APPROVE,
    reject: _vm.btnStatus === _vm.options.REJECT,
  },attrs:{"data-testid":_vm.dataTestId},on:{"click":function($event){return _vm.onBtnClick(_vm.btnStatus)},"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = ''}}},[(_vm.icon)?_c('i-icon',{staticClass:"icon",class:_vm.active
        ? _vm.activeClass
        : _vm.hovering
        ? 'i-text-neutral-90'
        : 'i-text-neutral-80',attrs:{"symbol":_vm.icon,"size":16}}):_vm._e(),_c('span',{staticClass:"label d-flex flex-row"},[_vm._v(_vm._s(_vm.label))]),(_vm.rightIcon)?_c('i-icon',{staticClass:"right-icon",class:_vm.active
        ? _vm.activeClass
        : _vm.hovering
        ? 'i-text-neutral-80'
        : 'i-text-neutral-70',attrs:{"symbol":_vm.rightIcon,"size":16}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }